export default "__VITE_ASSET__1c713b6c__"